/* ==========================================================================
   KiddoJoy - Bewertungen, Anzeige
   --------------------------------------------------------------------------
   Liest window.KJ_REVIEWS aus assets/kj-reviews.js und baut daraus Liste,
   Filter, Sortierung und den Knopf "Mehr Bewertungen anzeigen".

   Warum nicht als Theme-Blöcke: Shopify erlaubt höchstens 50 Blöcke je
   Abschnitt. Bei 137 Bewertungen ist der Editor ausserdem unbedienbar.
   Deshalb eine Datei, die man in einem Rutsch pflegen oder aus einem Export
   erzeugen kann.

   Ohne JavaScript bleibt der Kasten mit Durchschnitt, Verteilung und
   Kundenfotos sichtbar, er wird serverseitig aus dem Abschnitt gerendert.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.querySelector('[data-rv]');
  if (!root) return;

  var DATA = (window.KJ_REVIEWS || []).slice();
  if (!DATA.length) return;

  /* ------------------------------------------------------------- Optionen */

  var step = parseInt(root.getAttribute('data-step'), 10) || 9;
  var firstBatch = parseInt(root.getAttribute('data-first'), 10) || 9;
  var clampChars = 190;

  var listEl = root.querySelector('[data-rv-list]');
  var moreEl = root.querySelector('[data-rv-more]');
  var countEl = root.querySelector('[data-rv-count]');
  var emptyEl = root.querySelector('[data-rv-empty]');
  var sortEl = root.querySelector('[data-rv-sort]');
  var resetEl = root.querySelector('[data-rv-reset]');
  var chipEls = root.querySelectorAll('[data-rv-chip]');
  var barEls = root.querySelectorAll('[data-rv-bar]');

  var state = {
    stars: 0,                                             // 0 = alle
    product: root.getAttribute('data-product') || '',     // '' = alle
    sort: 'neu',
    shown: firstBatch
  };

  /* ------------------------------------------------- Kindliche Zeichnungen */
  /* Acht Tiere, fünf Farbpaare. Die Zuordnung ergibt sich aus dem Namen,
     damit dieselbe Person immer dasselbe Gesicht bekommt.                   */

  var TONES = [
    { bg: '#f6d7c4', ink: '#8a4b2a' }, // Apricot
    { bg: '#d9e4c8', ink: '#54682f' }, // Salbei
    { bg: '#cfe0ee', ink: '#31597a' }, // Himmel
    { bg: '#f5e2ab', ink: '#8a6b16' }, // Sonne
    { bg: '#eed6de', ink: '#8b4a5e' }  // Rosé
  ];

  var FACES = [
    // Bär
    '<circle cx="15" cy="14" r="7" fill="{ink}" opacity=".9"/><circle cx="33" cy="14" r="7" fill="{ink}" opacity=".9"/>' +
    '<circle cx="24" cy="27" r="16" fill="{ink}"/><ellipse cx="24" cy="33" rx="8" ry="6.5" fill="{bg}"/>' +
    '<circle cx="18" cy="24" r="2.1" fill="{bg}"/><circle cx="30" cy="24" r="2.1" fill="{bg}"/>' +
    '<ellipse cx="24" cy="30" rx="2.6" ry="2" fill="{ink}"/><path d="M24 32v2.4M24 34.4c-1.6 1.6-4 .6-4-1M24 34.4c1.6 1.6 4 .6 4-1" stroke="{ink}" stroke-width="1.5" fill="none" stroke-linecap="round"/>',
    // Hase
    '<ellipse cx="17" cy="12" rx="4.2" ry="10" fill="{ink}"/><ellipse cx="31" cy="12" rx="4.2" ry="10" fill="{ink}"/>' +
    '<ellipse cx="17" cy="13" rx="1.8" ry="6" fill="{bg}"/><ellipse cx="31" cy="13" rx="1.8" ry="6" fill="{bg}"/>' +
    '<circle cx="24" cy="31" r="14" fill="{ink}"/>' +
    '<circle cx="19" cy="29" r="2" fill="{bg}"/><circle cx="29" cy="29" r="2" fill="{bg}"/>' +
    '<path d="M24 33.5l-2.2-2h4.4Z" fill="{bg}"/><path d="M24 35.5c-1.5 1.6-3.8.8-3.8-.9M24 35.5c1.5 1.6 3.8.8 3.8-.9" stroke="{bg}" stroke-width="1.4" fill="none" stroke-linecap="round"/>',
    // Fuchs
    '<path d="M9 12l7 9-4 6ZM39 12l-7 9 4 6Z" fill="{ink}"/>' +
    '<path d="M24 12c9 0 15 8 15 16s-7 13-15 13S9 36 9 28s6-16 15-16Z" fill="{ink}"/>' +
    '<path d="M24 27c5 0 9 4 9 8s-4 6-9 6-9-2-9-6 4-8 9-8Z" fill="{bg}"/>' +
    '<circle cx="18" cy="25" r="2.1" fill="{bg}"/><circle cx="30" cy="25" r="2.1" fill="{bg}"/>' +
    '<ellipse cx="24" cy="32" rx="2.4" ry="1.9" fill="{ink}"/>',
    // Katze
    '<path d="M11 22 9 8l12 6ZM37 22l2-14-12 6Z" fill="{ink}"/>' +
    '<circle cx="24" cy="28" r="15" fill="{ink}"/>' +
    '<path d="M17 26c1.6-2 4.4-2 6 0M25 26c1.6-2 4.4-2 6 0" stroke="{bg}" stroke-width="2.2" fill="none" stroke-linecap="round"/>' +
    '<path d="M24 32l-2 1.6h4Z" fill="{bg}"/>' +
    '<path d="M24 34c-1.4 1.8-3.8 1-3.8-.8M24 34c1.4 1.8 3.8 1 3.8-.8" stroke="{bg}" stroke-width="1.4" fill="none" stroke-linecap="round"/>' +
    '<path d="M9 30h5M9 34h5M39 30h-5M39 34h-5" stroke="{bg}" stroke-width="1.2" stroke-linecap="round" opacity=".7"/>',
    // Eule
    '<path d="M12 16l3-8 6 5ZM36 16l-3-8-6 5Z" fill="{ink}"/>' +
    '<ellipse cx="24" cy="27" rx="15" ry="16" fill="{ink}"/>' +
    '<circle cx="18" cy="24" r="6" fill="{bg}"/><circle cx="30" cy="24" r="6" fill="{bg}"/>' +
    '<circle cx="18" cy="24" r="2.4" fill="{ink}"/><circle cx="30" cy="24" r="2.4" fill="{ink}"/>' +
    '<path d="M24 30l-3 4h6Z" fill="{bg}"/>' +
    '<path d="M13 36c4 3 18 3 22 0" stroke="{bg}" stroke-width="1.4" fill="none" stroke-linecap="round" opacity=".6"/>',
    // Frosch
    '<circle cx="15" cy="14" r="7" fill="{ink}"/><circle cx="33" cy="14" r="7" fill="{ink}"/>' +
    '<circle cx="15" cy="14" r="3.4" fill="{bg}"/><circle cx="33" cy="14" r="3.4" fill="{bg}"/>' +
    '<circle cx="15" cy="14" r="1.5" fill="{ink}"/><circle cx="33" cy="14" r="1.5" fill="{ink}"/>' +
    '<path d="M24 17c9 0 15 6 15 13s-6 11-15 11-15-4-15-11 6-13 15-13Z" fill="{ink}"/>' +
    '<path d="M15 32c4 5 14 5 18 0" stroke="{bg}" stroke-width="2.2" fill="none" stroke-linecap="round"/>',
    // Panda
    '<circle cx="13" cy="14" r="6.5" fill="{ink}"/><circle cx="35" cy="14" r="6.5" fill="{ink}"/>' +
    '<circle cx="24" cy="28" r="15" fill="{ink}" opacity=".18"/>' +
    '<circle cx="24" cy="28" r="15" fill="none" stroke="{ink}" stroke-width="2"/>' +
    '<ellipse cx="18" cy="25" rx="4.4" ry="5.2" fill="{ink}"/><ellipse cx="30" cy="25" rx="4.4" ry="5.2" fill="{ink}"/>' +
    '<circle cx="18" cy="25" r="1.7" fill="{bg}"/><circle cx="30" cy="25" r="1.7" fill="{bg}"/>' +
    '<ellipse cx="24" cy="33" rx="2.6" ry="2" fill="{ink}"/>' +
    '<path d="M24 35v1.8M24 36.8c-1.5 1.5-3.6.6-3.6-.9M24 36.8c1.5 1.5 3.6.6 3.6-.9" stroke="{ink}" stroke-width="1.4" fill="none" stroke-linecap="round"/>',
    // Elefant
    '<ellipse cx="10" cy="26" rx="7" ry="9" fill="{ink}" opacity=".85"/><ellipse cx="38" cy="26" rx="7" ry="9" fill="{ink}" opacity=".85"/>' +
    '<circle cx="24" cy="25" r="13" fill="{ink}"/>' +
    '<circle cx="19" cy="23" r="2" fill="{bg}"/><circle cx="29" cy="23" r="2" fill="{bg}"/>' +
    '<path d="M24 30v6c0 3 4 4 5 1" stroke="{bg}" stroke-width="3.4" fill="none" stroke-linecap="round"/>'
  ];

  function hash(str) {
    var h = 0, i;
    for (i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) % 100000;
    return h;
  }

  function avatar(review) {
    var h = hash(review.a + review.i);
    var tone = TONES[h % TONES.length];
    var face = FACES[(h >> 2) % FACES.length];
    var svg = face.split('{ink}').join(tone.ink).split('{bg}').join(tone.bg);
    return '<span class="rv-face" style="background:' + tone.bg + '" aria-hidden="true">' +
           '<svg viewBox="0 0 48 48">' + svg + '</svg></span>';
  }

  /* ------------------------------------------------------------- Bausteine */

  var STAR =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.2c.5 0 .9.3 1.1.8l1.9 4.2 4.5.5c1.1.1 1.5 1.4.7 2.1l-3.4 3 1 4.5c.2 1.1-1 1.9-1.9 1.3L12 17.2l-3.9 2.4c-.9.6-2.1-.2-1.9-1.3l1-4.5-3.4-3c-.8-.7-.4-2 .7-2.1l4.5-.5 1.9-4.2c.2-.5.6-.8 1.1-.8Z"/></svg>';

  function stars(n, cls) {
    var out = '<span class="rv-stars ' + (cls || '') + '" role="img" aria-label="' + n + ' von 5 Sternen">';
    for (var i = 1; i <= 5; i++) out += '<i class="' + (i <= n ? 'on' : 'off') + '">' + STAR + '</i>';
    return out + '</span>';
  }

  var MONTHS = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];

  function niceDate(iso) {
    var p = iso.split('-');
    var d = new Date(+p[0], +p[1] - 1, +p[2]);
    var days = Math.round((Date.now() - d.getTime()) / 86400000);
    if (days < 1) return 'heute';
    if (days === 1) return 'gestern';
    if (days < 7) return 'vor ' + days + ' Tagen';
    if (days < 14) return 'vor einer Woche';
    if (days < 35) return 'vor ' + Math.round(days / 7) + ' Wochen';
    return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* -------------------------------------------------- Hilfreich-Abstimmung */

  var VOTE_KEY = 'kj-review-votes';
  var votes = {};
  try { votes = JSON.parse(localStorage.getItem(VOTE_KEY) || '{}'); } catch (e) { votes = {}; }

  function saveVotes() {
    try { localStorage.setItem(VOTE_KEY, JSON.stringify(votes)); } catch (e) {}
  }

  /* ------------------------------------------------------------- Filterung */

  /* Ist im Abschnitt ein Produkt vorgewaehlt, ist dessen Menge der Bezugswert
     fuer Durchschnitt, Verteilung und Zaehler. Sonst zaehlt der ganze Bestand.
     Sonst stuende auf der Lernturm-Seite ein Schnitt, der auch Bewertungen
     ganz anderer Moebel enthaelt. */
  var fixedProduct = root.getAttribute('data-product') || '';

  function scope() {
    if (!fixedProduct) return DATA;
    return DATA.filter(function (r) { return r.p === fixedProduct; });
  }

  function filtered() {
    var out = DATA.filter(function (r) {
      if (state.stars && r.r !== state.stars) return false;
      if (state.product && r.p !== state.product) return false;
      return true;
    });

    out.sort(function (a, b) {
      if (state.sort === 'beste') return b.r - a.r || (a.d < b.d ? 1 : -1);
      if (state.sort === 'kritisch') return a.r - b.r || (a.d < b.d ? 1 : -1);
      if (state.sort === 'hilfreich') return (b.h + (votes[b.i] || 0)) - (a.h + (votes[a.i] || 0));
      if (state.sort === 'foto') return (b.m ? 1 : 0) - (a.m ? 1 : 0) || (a.d < b.d ? 1 : -1);
      return a.d < b.d ? 1 : -1;
    });

    return out;
  }

  /* -------------------------------------------------------------- Rendering */

  function card(r) {
    var help = (r.h || 0) + (votes[r.i] ? 1 : 0);
    var long = r.b.length > clampChars;

    var html = '<article class="rv-card" data-id="' + r.i + '">';

    html += '<header class="rv-card__head">' + avatar(r) +
            '<span class="rv-card__who"><b>' + esc(r.a) + '</b>' +
            '<span class="rv-card__sub">' + esc(r.c) +
            (r.v ? ' <span class="rv-check" title="Bestellung zugeordnet">' +
                   '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M6.4 11.6 3.2 8.4l1.1-1.1 2.1 2.1 5-5L12.5 5.5Z"/></svg>' +
                   'Verifizierter Kauf</span>' : '') +
            '</span></span></header>';

    html += '<div class="rv-card__rating">' + stars(r.r) +
            '<time datetime="' + r.d + '">' + niceDate(r.d) + '</time></div>';

    if (r.t) html += '<h3 class="rv-card__title">' + esc(r.t) + '</h3>';

    html += '<div class="rv-card__body' + (long ? ' is-clamped' : '') + '"><p>' + esc(r.b) + '</p></div>';
    if (long) html += '<button type="button" class="rv-card__more" data-rv-expand>Weiterlesen</button>';

    if (r.m) {
      html += '<figure class="rv-card__photo"><img src="' + root.getAttribute('data-base') + r.m +
              '" alt="Kundenfoto zu ' + esc(r.p) + '" loading="lazy" decoding="async" width="900" height="900"></figure>';
    }

    html += '<footer class="rv-card__foot">' +
            '<span class="rv-tag">' + esc(r.p) + '</span>' +
            (r.e ? '<span class="rv-rec"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5S3.5 15 3.5 9.4A4.6 4.6 0 0 1 12 6.9a4.6 4.6 0 0 1 8.5 2.5c0 5.6-8.5 11.1-8.5 11.1Z"/></svg>Empfiehlt das Produkt</span>' : '') +
            '<button type="button" class="rv-help' + (votes[r.i] ? ' is-voted' : '') + '" data-rv-vote>' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 21H6a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3Zm2-11 3.6-6.4a1.6 1.6 0 0 1 3 .8V9h4a2 2 0 0 1 2 2.3l-1.3 8A2 2 0 0 1 20.3 21H11Z"/></svg>' +
            'Hilfreich <b>' + help + '</b></button>' +
            '</footer>';

    return html + '</article>';
  }

  function render() {
    var rows = filtered();
    var slice = rows.slice(0, state.shown);

    listEl.innerHTML = slice.map(card).join('');
    listEl.hidden = rows.length === 0;
    emptyEl.hidden = rows.length !== 0;

    var basis = scope().length;
    countEl.textContent = rows.length === basis
      ? basis + ' Bewertungen'
      : rows.length + ' von ' + basis + ' Bewertungen';

    resetEl.hidden = !(state.stars || state.product);

    var rest = rows.length - slice.length;
    if (rest > 0) {
      moreEl.hidden = false;
      moreEl.querySelector('span').textContent = 'Mehr Bewertungen anzeigen (' + rest + ')';
    } else {
      moreEl.hidden = true;
    }

    Array.prototype.forEach.call(barEls, function (b) {
      b.setAttribute('aria-pressed', String(+b.getAttribute('data-rv-bar') === state.stars));
    });
    Array.prototype.forEach.call(chipEls, function (c) {
      c.setAttribute('aria-pressed', String(c.getAttribute('data-rv-chip') === state.product));
    });
  }

  function reset(keepSort) {
    state.stars = 0;
    state.product = '';
    state.shown = firstBatch;
    if (!keepSort) state.sort = 'neu';
    if (sortEl && !keepSort) sortEl.value = 'neu';
    render();
  }

  /* ---------------------------------------------------------------- Events */

  Array.prototype.forEach.call(barEls, function (b) {
    b.addEventListener('click', function () {
      var v = +b.getAttribute('data-rv-bar');
      state.stars = state.stars === v ? 0 : v;
      state.shown = firstBatch;
      render();
    });
  });

  Array.prototype.forEach.call(chipEls, function (c) {
    c.addEventListener('click', function () {
      var v = c.getAttribute('data-rv-chip');
      state.product = state.product === v ? '' : v;
      state.shown = firstBatch;
      render();
    });
  });

  if (sortEl) {
    sortEl.addEventListener('change', function () {
      state.sort = sortEl.value;
      state.shown = firstBatch;
      render();
    });
  }

  if (resetEl) resetEl.addEventListener('click', function () { reset(true); });

  moreEl.addEventListener('click', function () {
    var before = listEl.querySelectorAll('.rv-card').length;
    state.shown += step;
    render();
    var cards = listEl.querySelectorAll('.rv-card');
    if (cards[before]) cards[before].querySelector('.rv-card__title, .rv-card__body').setAttribute('tabindex', '-1');
    if (cards[before]) cards[before].querySelector('.rv-card__title, .rv-card__body').focus({ preventScroll: true });
  });

  listEl.addEventListener('click', function (e) {
    var expand = e.target.closest('[data-rv-expand]');
    if (expand) {
      var box = expand.previousElementSibling;
      var open = box.classList.toggle('is-clamped');
      expand.textContent = open ? 'Weiterlesen' : 'Weniger anzeigen';
      return;
    }

    var vote = e.target.closest('[data-rv-vote]');
    if (vote) {
      var id = vote.closest('.rv-card').getAttribute('data-id');
      var b = vote.querySelector('b');
      if (votes[id]) { delete votes[id]; b.textContent = +b.textContent - 1; vote.classList.remove('is-voted'); }
      else { votes[id] = 1; b.textContent = +b.textContent + 1; vote.classList.add('is-voted'); }
      saveVotes();
    }
  });

  /* ------------------------------------------- Kopfzahlen aus den Daten --- */
  /* Falls die Zahlen im Theme-Editor von der Datei abweichen, gewinnt die
     Datei. So kann die Anzeige nicht auseinanderlaufen.                     */

  (function syncSummary() {
    var set = scope();
    var total = set.length;
    if (!total) return;

    var sum = 0, by = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }, rec = 0;
    set.forEach(function (r) { sum += r.r; by[r.r]++; if (r.e) rec++; });

    var avg = Math.round((sum / total) * 10) / 10;
    var numEl = root.querySelector('[data-rv-avg]');
    var totEl = root.querySelector('[data-rv-total]');
    var recEl = root.querySelector('[data-rv-rec]');
    var starEl = root.querySelector('[data-rv-avgstars]');

    if (numEl) numEl.textContent = avg.toFixed(1).replace('.', ',');
    if (totEl) totEl.textContent = total;
    if (recEl) recEl.textContent = Math.round((rec / total) * 100);
    if (starEl) {
      starEl.style.setProperty('--fill', (avg / 5 * 100).toFixed(2) + '%');
      starEl.setAttribute('aria-label', 'Durchschnitt ' + avg.toFixed(1).replace('.', ',') + ' von 5 Sternen');
    }

    Array.prototype.forEach.call(barEls, function (b) {
      var v = +b.getAttribute('data-rv-bar');
      var n = by[v];
      var pct = Math.round((n / total) * 100);
      var fillEl = b.querySelector('i');
      var num = b.querySelector('.rv-bar__n');
      if (fillEl) fillEl.style.width = pct + '%';
      if (num) num.textContent = n;
      b.setAttribute('aria-label', n + ' Bewertungen mit ' + v + ' Sternen, nach ' + v + ' Sternen filtern');
      b.disabled = n === 0;
    });

    /* Bewertungssterne fuer die Google-Suche. Nur wenn ein Produkt vorgewaehlt
       ist, denn nur dann gehoeren die Zahlen wirklich zu diesem Artikel. */
    var name = root.getAttribute('data-name');
    if (fixedProduct && name && root.getAttribute('data-schema') === 'true') {
      var ld = document.createElement('script');
      ld.type = 'application/ld+json';
      ld.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: name,
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: avg.toFixed(1),
          reviewCount: total,
          bestRating: 5,
          worstRating: 1
        }
      });
      document.head.appendChild(ld);
    }
  })();

  render();
})();
